import React from 'react';
import { Anchor } from 'lucide-react';
import { Gear } from './animations/Gear';

export default function Footer() {
  return (
    <footer className="relative bg-[#040609] border-t border-cyan-500/15 overflow-hidden">
      <div className="absolute -top-20 right-1/2 text-cyan-400/[0.04]">
        <div className="spin-slow"><Gear size={300} teeth={18} /></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="grid md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="relative w-10 h-10 border border-cyan-400/40 flex items-center justify-center">
                <Anchor className="w-4 h-4 text-cyan-400" />
              </div>
              <div>
                <div className="font-display text-2xl font-bold tracking-[0.2em] text-white">UTKU</div>
                <div className="text-[9px] font-mono tracking-[0.3em] text-cyan-400/60">SUBMARINE · TR-2026</div>
              </div>
            </div>
            <p className="text-slate-500 text-sm mt-5 max-w-md leading-relaxed">
              Mavi vatanın derinliklerinde sessiz caydırıcılık. Yerli ve milli
              mühendislikle inşa edilen UTKU sınıfı denizaltılar.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] font-mono tracking-[0.25em] text-cyan-400/60">NAVİGATİON</div>
            <ul className="mt-4 space-y-2 text-sm">
              {['Anasayfa', 'Teknik', 'Teknoloji', 'Misyonlar', 'Galeri', 'İletişim'].map((l) => (
                <li key={l}><a href="#" className="text-slate-400 hover:text-cyan-300 transition-colors">{l}</a></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] font-mono tracking-[0.25em] text-cyan-400/60">KAYIT</div>
            <div className="mt-4 space-y-2 text-sm text-slate-400">
              <div className="flex justify-between py-1.5 border-b border-dashed border-cyan-500/10">
                <span>Class</span><span className="text-cyan-300 font-mono">UTKU · SSK</span>
              </div>
              <div className="flex justify-between py-1.5 border-b border-dashed border-cyan-500/10">
                <span>Hull No</span><span className="text-cyan-300 font-mono">S-401</span>
              </div>
              <div className="flex justify-between py-1.5 border-b border-dashed border-cyan-500/10">
                <span>Builder</span><span className="text-cyan-300 font-mono">GÖLÇÜK NSY</span>
              </div>
              <div className="flex justify-between py-1.5">
                <span>Status</span>
                <span className="text-emerald-400 font-mono flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 bg-emerald-400 blink" /> SEA TRIALS
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-cyan-500/10 flex flex-wrap items-center justify-between gap-4 text-[10px] font-mono tracking-[0.25em] text-slate-500">
          <span>© 2026 UTKU PROGRAM. TÜM HAKLARI SAKLIDIR.</span>
          <span>CLASSİFİED · INTERNAL USE</span>
          <span className="flex items-center gap-2 text-cyan-400/70">
            <span className="w-1.5 h-1.5 bg-cyan-400 blink" /> SİSTEM ÇEVRİMİÇİ
          </span>
        </div>
      </div>
    </footer>
  );
}
